export default __webpack_public_path__ + "static/media/footer-share.c4123556.svg";